import React from 'react';
import { authorPropTypes } from './AuthorPropTypes';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Author.module.scss';
const Author = ({
  picture,
  title,
  name,
  verifiedLabel,
  classname,
  children
}) => {
  if (!name) {
    return null;
  }
  const avatarSize = {
    width: 24,
    height: 24
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${children ? styles.rootHasChildren : ''} ${classname || ''}`
  }, (picture === null || picture === void 0 ? void 0 : picture.src) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.src,
      ...avatarSize
    },
    alt: picture.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }), !(picture !== null && picture !== void 0 && picture.src) && /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: styles.rootPicture
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "avatarPlaceholder",
    size: avatarSize,
    classname: styles.rootIcon
  })), title && /*#__PURE__*/React.createElement("span", {
    className: styles.rootTitle
  }, title), /*#__PURE__*/React.createElement("span", {
    className: styles.rootName
  }, name), verifiedLabel && /*#__PURE__*/React.createElement("div", {
    className: styles.rootVerified
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "verified",
    classname: styles.rootVerifiedIcon,
    size: {
      width: 20,
      height: 20
    }
  }), verifiedLabel), children);
};
export default Author;